@let kunde = letregisterService.selectedKunde();
@if (kunde) {
  <h2 class="mb-4">
    Aftaler for {{ kunde.navn }} ({{ kunde.cprNummer | cprNummer }}) - Reg.Nr.
    {{ kunde.pengeinstitut?.regnr }}
  </h2>
}
@if (aktiveAftaler().length > 0) {
  <h3 class="mb-2">Nuværende aftaler</h3>
  <p-table
    [value]="aktiveAftaler()"
    [showGridlines]="true"
    stripedRows
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelectAktive($event)"
    [(selection)]="selectionAktive"
    dataKey="id">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 300px">Letsikring nr</th>
        <th style="width: 400px">Produkt</th>
        <th style="width: 300px">Ændret</th>
        <th>Ændret af</th>
        <th>Revision</th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="aktiveAftaler()" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td>{{ item.letsikringNr }}</td>
        <td>
          {{ letregisterService.getProduktNavn(item) }}
          @for (
            t of item.gaeldendeRevision.tilknyttedeLetsikringRisiko;
            track t
          ) {
            <div>{{ t.produktNavn }}</div>
          }
        </td>
        <td class="numbers">
          {{
            item.gaeldendeRevision.oprettelsesDato | date: 'dd-MM-yyyy HH:mm:ss'
          }}
        </td>
        <td>{{ item.gaeldendeRevision.oprettetAf }}</td>
        <td>{{ item.gaeldendeRevision.revisionNr }}</td>
      </tr>
    </ng-template>
  </p-table>
}
@if (udgaaedeAftaler().length > 0) {
  <h3 class="mt-8 mb-2">Udgåede aftaler</h3>
  <p-table
    [value]="udgaaedeAftaler()"
    [showGridlines]="true"
    stripedRows
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelectUdgaaet($event)"
    [(selection)]="selectionUdgaaede"
    dataKey="id">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 300px">Letsikring nr</th>
        <th style="width: 400px">Produkt</th>
        <th>Udgået</th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="udgaaedeAftaler()" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td>{{ item.letsikringNr }}</td>
        <td>{{ letregisterService.getProduktNavn(item) }}</td>
        <td class="numbers">
          {{ item.udgaaetDato | date: 'dd-MM-yyyy' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
}
